import type { FaireProductEntity } from "../../entity_types/product";

export const p_b23scdhpkp: FaireProductEntity = {
  token: "p_b23scdhpkp",
  type: "product",
  name: "Cool Mom Gym Crew Socks",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/fastly/1b9025a0cbf9476279a2c22d1ceacf608617bb704d01bc6cc46b13a94a061f8e.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/00229b329cb41f3d7c2654968cc04e1cdb0156aaaf793347a9bb1e315fa48d1b.jpeg",
    "https://cdn.faire.com/fastly/f3ce9abf6eea195493d78a79a903ad6d7c7df20b1222b13b21f69f1dc3d0c4ca.jpeg",
    "https://cdn.faire.com/fastly/e905299ebf60a9a716c18bd0d111c686e98f2685ae50ec17f954482488815cd4.jpeg",
    "https://cdn.faire.com/fastly/c4d0036de203783114719b53521189aa396a80503f4e9203addfd2b8e51dfe6d.jpeg",
    "https://cdn.faire.com/fastly/03b54878e97f7360ee2f66137bb9243fc8054a2764d0ea389dab3c050ffc4335.jpeg",
    "https://cdn.faire.com/fastly/431ddd6076e4717fcf75c0a0372d56f98aad122443d32458b7377feb1ce93445.jpeg",
    "https://cdn.faire.com/fastly/6dd30302c47024b8fa213d091019b574f6c912a45227833d96bb666789ff59eb.jpeg",
    "https://cdn.faire.com/fastly/883a74d3f4ee0f87a02e0b2248059a6dadbf23d137c38075671dd43fb71b6515.jpeg"
  ],
  priceDollars: 6.75,
  description: "There are NO rules in these socks. They're not like *regular* socks, They're *cool* socks. There are moms, and there are COOL moms... and only one way to know the difference. 🧦\n\nPerfect Mother’s Day gift!\n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance. \n\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products - be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:27:51.871Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
